<template>
  <div v-loading="loading">
    <search-input
      placeholder="Поиск по названию"
      style="width: 300px"
      v-model="filters.search"
      @change="filtersChanged"
    >
    </search-input>

    <div class="category-block">
      <el-table :data="categories" border>
        <el-table-column prop="name" label="Название" width="500"></el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column width="90" align="right" label="Действия">
          <template v-slot="scope">
            <el-popconfirm
              style="float:left"
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить категорию и все компетенции которые входят в нее?"
              @confirm="deleteCategory(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
            <el-button
              class="table-action-button"
              size="mini"
              round
              icon="fas fa-pen"
              @click="onEditCategory(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadCategories"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "categories-component",
  components: {Paginator, SearchInput},
  mixins: [paginator],
  props: {
    onEditCategory: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      categories: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      this.loading = true;
      this.$api.evaluation.categorySearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.categories = data.categories;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteCategory(category) {
      this.loading = true;
      this.$api.evaluation.categoryDelete({
        ids: [category.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Категория успешно удалена'
          });
        })
        .finally(() => {
          this.loadCategories();
        })
    },
    filtersChanged() {
      this.loadCategories();
    }
  }
}
</script>

<style lang="scss">
  .category-block {
    margin: 25px 0;
  }
</style>